// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.addQuestion-modal-container {}

.addQuestion-modal-container form>div {
    margin-bottom: 13px;
}

.addQuestion-modal-container form .form-control {
    background-color: var(--field-background) !important;
    border: none !important;
    height: 50px !important;
    padding: 10px 20px !important;
    font-family: var(--Inter-SemiBold600);
    font-size: 16px !important;
    color: var(--table-text-color) !important;
}

.addQuestion-modal-container form .form-control::placeholder {
    font-family: var(--inter-Regular);
    /* color: var(--placeholder-grey); */
}

.addQuestion-modal-container form>div:nth-child(1) {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
}

.addQuestion-modal-container form>div:nth-child(1)>div {
    width: 49%;
}

.addQuestion-modal-container form>div:nth-child(1) .css-b62m3t-container {
    /* width: 49%; */
    /* height: 68px; */
    border-radius: 15px !important;
}

.addQuestion-modal-container form>div:nth-child(1) .css-b62m3t-container .css-1yhe670-control {
    border-radius: 15px !important;
    background: var(--field-background) !important;
    border: 1px solid var(--field-background) !important;
    height: 50px !important;
    padding: 0px 12px;
}

.addQuestion-modal-container form>div:nth-child(1) .css-b62m3t-container .css-1nkf596-control {
    border-radius: 15px;
    background: var(--field-background) !important;
    /* border: none !important; */
    height: 50px !important;
    padding: 0px 12px;
}

.addQuestion-modal-container form>div:nth-child(1) .css-b62m3t-container .css-1nkf596-control svg {
    width: 20px !important;
    height: 20px !important;
}

.addQuestion-modal-container form>div:nth-child(1) .css-b62m3t-container .css-1yhe670-control .css-tj5bde-Svg {
    fill: var(--black) !important;
    width: 20px !important;
    height: 20px !important;
}

.css-lnmdiq5-menu {
    height: 500px !important;
}

.options-container {
    display: flex;
    flex-direction: 'row';
    justify-content: flex-start;
    flex-wrap: wrap;
    gap: 1.33%
}

.options-container .options {
    width: 24%;
    position: relative;
}

.options-container input {
    margin-bottom: 13px;
    border: 1px solid var(--field-background) !important;
}

.options-container .options svg {
    position: absolute;
    top: 3px;
    right: 4px;
    padding: 2px;
    border: .5px solid var(--inactive-red-text);
    border-radius: 50%;
}

.options-container .options svg:hover {
    cursor: pointer;
}

input.form-control:focus {
    border: 1px solid var(--purple) !important;
}

.addQuestion-modal-container .placeHolderStyle {
    font-size: 16px !important;
    line-height: 16px !important;
}


.options-container .deleteButton {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 50px !important;
    padding: 10px 40px !important;
    border-radius: 15px !important;
    vertical-align: 'center';
    cursor: pointer;
    font-size: 16px !important;
}



/* /Styles for diabled  */

.addQuestion-modal-container form>div:nth-child(1) .css-3iigni-container {
    border-radius: 15px !important;
}

.addQuestion-modal-container form>div:nth-child(1) .css-3iigni-container .css-n3rqp9-control {
    border-radius: 15px !important;
    background: var(--field-background) !important;
    border: 1px solid var(--field-background) !important;
    height: 50px !important;
    padding: 0px 12px;
}


.addQuestion-modal-container form>div:nth-child(1) .css-3iigni-container .css-n3rqp9-control .css-tj5bde-Svg {
    fill: var(--black) !important;
    width: 20px !important;
    height: 20px !important;
}


@media(max-width:768px) {
    .addQuestion-modal-container form>div:nth-child(1) {
        flex-direction: column !important;
    }

    .addQuestion-modal-container form>div:nth-child(1)>div:first-child {
        margin-bottom: 13px;
    }

    .addQuestion-modal-container form>div:nth-child(1)>div {
        width: 100%;
    }

    .options-container {
        gap: 2%;
    }

    .options-container .options {
        width: 49%;
        position: relative;
    }
}

@media(max-width:400px) {
    .addQuestion-modal-container form>div:nth-child(1)>div:first-child {
        margin-bottom: 13px;
    }

    .addQuestion-modal-container form>div:nth-child(1)>div {
        width: 100%;
    }

    .options-container {
        gap: none !important;
    }

    .options-container .options {
        width: 100%;
        position: relative;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/modals/addQuestionModal/AddQuestionModal.css"],"names":[],"mappings":"AAAA,8BAA8B;;AAE9B;IACI,mBAAmB;AACvB;;AAEA;IACI,oDAAoD;IACpD,uBAAuB;IACvB,uBAAuB;IACvB,6BAA6B;IAC7B,qCAAqC;IACrC,0BAA0B;IAC1B,yCAAyC;AAC7C;;AAEA;IACI,iCAAiC;IACjC,oCAAoC;AACxC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;AACf;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;IAC9B,8CAA8C;IAC9C,oDAAoD;IACpD,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,8CAA8C;IAC9C,6BAA6B;IAC7B,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,6BAA6B;IAC7B,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,2BAA2B;IAC3B,eAAe;IACf;AACJ;;AAEA;IACI,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,oDAAoD;AACxD;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,YAAY;IACZ,2CAA2C;IAC3C,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,0BAA0B;IAC1B,4BAA4B;AAChC;;;AAGA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,uBAAuB;IACvB,6BAA6B;IAC7B,8BAA8B;IAC9B,wBAAwB;IACxB,eAAe;IACf,0BAA0B;AAC9B;;;;AAIA,yBAAyB;;AAEzB;IACI,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;IAC9B,8CAA8C;IAC9C,oDAAoD;IACpD,uBAAuB;IACvB,iBAAiB;AACrB;;;AAGA;IACI,6BAA6B;IAC7B,sBAAsB;IACtB,uBAAuB;AAC3B;;;AAGA;IACI;QACI,iCAAiC;IACrC;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,OAAO;IACX;;IAEA;QACI,UAAU;QACV,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,mBAAmB;IACvB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,WAAW;QACX,kBAAkB;IACtB;AACJ","sourcesContent":[".addQuestion-modal-container {}\n\n.addQuestion-modal-container form>div {\n    margin-bottom: 13px;\n}\n\n.addQuestion-modal-container form .form-control {\n    background-color: var(--field-background) !important;\n    border: none !important;\n    height: 50px !important;\n    padding: 10px 20px !important;\n    font-family: var(--Inter-SemiBold600);\n    font-size: 16px !important;\n    color: var(--table-text-color) !important;\n}\n\n.addQuestion-modal-container form .form-control::placeholder {\n    font-family: var(--inter-Regular);\n    /* color: var(--placeholder-grey); */\n}\n\n.addQuestion-modal-container form>div:nth-child(1) {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    width: 100%;\n}\n\n.addQuestion-modal-container form>div:nth-child(1)>div {\n    width: 49%;\n}\n\n.addQuestion-modal-container form>div:nth-child(1) .css-b62m3t-container {\n    /* width: 49%; */\n    /* height: 68px; */\n    border-radius: 15px !important;\n}\n\n.addQuestion-modal-container form>div:nth-child(1) .css-b62m3t-container .css-1yhe670-control {\n    border-radius: 15px !important;\n    background: var(--field-background) !important;\n    border: 1px solid var(--field-background) !important;\n    height: 50px !important;\n    padding: 0px 12px;\n}\n\n.addQuestion-modal-container form>div:nth-child(1) .css-b62m3t-container .css-1nkf596-control {\n    border-radius: 15px;\n    background: var(--field-background) !important;\n    /* border: none !important; */\n    height: 50px !important;\n    padding: 0px 12px;\n}\n\n.addQuestion-modal-container form>div:nth-child(1) .css-b62m3t-container .css-1nkf596-control svg {\n    width: 20px !important;\n    height: 20px !important;\n}\n\n.addQuestion-modal-container form>div:nth-child(1) .css-b62m3t-container .css-1yhe670-control .css-tj5bde-Svg {\n    fill: var(--black) !important;\n    width: 20px !important;\n    height: 20px !important;\n}\n\n.css-lnmdiq5-menu {\n    height: 500px !important;\n}\n\n.options-container {\n    display: flex;\n    flex-direction: 'row';\n    justify-content: flex-start;\n    flex-wrap: wrap;\n    gap: 1.33%\n}\n\n.options-container .options {\n    width: 24%;\n    position: relative;\n}\n\n.options-container input {\n    margin-bottom: 13px;\n    border: 1px solid var(--field-background) !important;\n}\n\n.options-container .options svg {\n    position: absolute;\n    top: 3px;\n    right: 4px;\n    padding: 2px;\n    border: .5px solid var(--inactive-red-text);\n    border-radius: 50%;\n}\n\n.options-container .options svg:hover {\n    cursor: pointer;\n}\n\ninput.form-control:focus {\n    border: 1px solid var(--purple) !important;\n}\n\n.addQuestion-modal-container .placeHolderStyle {\n    font-size: 16px !important;\n    line-height: 16px !important;\n}\n\n\n.options-container .deleteButton {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 50px !important;\n    padding: 10px 40px !important;\n    border-radius: 15px !important;\n    vertical-align: 'center';\n    cursor: pointer;\n    font-size: 16px !important;\n}\n\n\n\n/* /Styles for diabled  */\n\n.addQuestion-modal-container form>div:nth-child(1) .css-3iigni-container {\n    border-radius: 15px !important;\n}\n\n.addQuestion-modal-container form>div:nth-child(1) .css-3iigni-container .css-n3rqp9-control {\n    border-radius: 15px !important;\n    background: var(--field-background) !important;\n    border: 1px solid var(--field-background) !important;\n    height: 50px !important;\n    padding: 0px 12px;\n}\n\n\n.addQuestion-modal-container form>div:nth-child(1) .css-3iigni-container .css-n3rqp9-control .css-tj5bde-Svg {\n    fill: var(--black) !important;\n    width: 20px !important;\n    height: 20px !important;\n}\n\n\n@media(max-width:768px) {\n    .addQuestion-modal-container form>div:nth-child(1) {\n        flex-direction: column !important;\n    }\n\n    .addQuestion-modal-container form>div:nth-child(1)>div:first-child {\n        margin-bottom: 13px;\n    }\n\n    .addQuestion-modal-container form>div:nth-child(1)>div {\n        width: 100%;\n    }\n\n    .options-container {\n        gap: 2%;\n    }\n\n    .options-container .options {\n        width: 49%;\n        position: relative;\n    }\n}\n\n@media(max-width:400px) {\n    .addQuestion-modal-container form>div:nth-child(1)>div:first-child {\n        margin-bottom: 13px;\n    }\n\n    .addQuestion-modal-container form>div:nth-child(1)>div {\n        width: 100%;\n    }\n\n    .options-container {\n        gap: none !important;\n    }\n\n    .options-container .options {\n        width: 100%;\n        position: relative;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
